import {forwardRef, ReactElement, Ref, RefAttributes} from "react";

/** A version of forwardRef that preserves generics */
export const forwardRefGeneric = forwardRef as <T, P = {}>(
    render: (props: P, ref: Ref<T>) => ReactElement | null
) => (props: P & RefAttributes<T>) => ReactElement | null;
